import { getInitialRangeState } from 'search/utils/getInitialRangeStateFromFacet';

export const getPriceStateFromUrl = (router) => {
  const lowestPriceCents = router?.query?.lowest_price_cents;
  if (!lowestPriceCents) return null;

  return getInitialRangeState(lowestPriceCents);
};
